import React from 'react';
import PropTypes from 'prop-types';
import LoadingText from '../common/LoadingText';
import server from '../../server';

class MessageAttachmentText extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      attachmentArray: [],
      isLoading: false,
      getMessageAttachmentRoute: `${server}/help-desk/conversation/get-message-attachment`,
    };
  }

  componentDidMount() {
    const { messageId } = this.props;

    const { getMessageAttachmentRoute } = this.state;

    fetch(getMessageAttachmentRoute, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        messageId,
      }),
    })
      .then((res) => res.json())
      .then((res) => this.setState({ attachmentArray: res }));
  }

  displayAttachment(attachment) {
    if (attachment) {
      return (
        <div>
          <i className="fa fa-paperclip" />
          &ensp;
          <span className="btn">{attachment.substring(20)}</span>
        </div>
      );
    }

    return <div />;
  }

  render() {
    const { attachmentArray, isLoading } = this.state;

    let attachment = '';

    if (attachmentArray[0]) {
      attachment = attachmentArray[0].attachment;
    }

    if (isLoading) {
      return <LoadingText />;
    }

    return <span>{this.displayAttachment(attachment)}</span>;
  }
}

MessageAttachmentText.propTypes = {
  messageId: PropTypes.number.isRequired,
};

export default MessageAttachmentText;
